var thirdPartySanitizer = require('sanitize-html');

var allowedTags = thirdPartySanitizer.defaults.allowedTags;
var allowedAttributes = thirdPartySanitizer.defaults.allowedAttributes;
var allowedSchemes = thirdPartySanitizer.defaults.allowedSchemes;
var disallowedTagMode = 'discard'; //also supports 'escape' and 'recursiveEscape'
var allowedSchemesByTag = thirdPartySanitizer.defaults.allowedSchemesByTag;
var expectedSelfClosingTags = thirdPartySanitizer.defaults.selfClosing;
var allowedSchemesAppliedToAttributes = thirdPartySanitizer.defaults.allowedSchemesAppliedToAttributes;
var allowRelativeProtocol = thirdPartySanitizer.defaults.allowProtocolRelative;


function sanitize(dangerousString, transformTagsOptions){
    var configs = {allowedTags: allowedTags,
        allowedAttributes: allowedAttributes,
        allowedSchemes: allowedSchemes,
        disallowedTagsMode: disallowedTagMode,
        selfClosing: expectedSelfClosingTags,
        allowedSchemesByTag: allowedSchemesByTag,
        allowedSchemesAppliedToAttributes: allowedSchemesAppliedToAttributes,
        allowProtocolRelative: allowRelativeProtocol,
        transformTags: transformTagsOptions || {}};
    return thirdPartySanitizer(dangerousString, configs);
}

module.exports = {allowedTags: allowedTags, 
    allowedAttributes: allowedAttributes, 
    allowedSchemes: allowedSchemes, 
    disallowedTagMode: disallowedTagMode, 
    allowedSchemesByTag: allowedSchemesByTag, 
    expectedSelfClosingTags: expectedSelfClosingTags, 
    allowedSchemesAppliedToAttributes: allowedSchemesAppliedToAttributes, 
    allowRelativeProtocol: allowRelativeProtocol,
    sanitize:sanitize};
